import MarkdownComponent from 'components/shared/MarkdownComponent';
import { useI18n } from 'hooks/useI18n';
import { UIOfferTeamMember } from 'interfaces/ui/ui-offer-team-member';
import { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import { StyledJobOfferLongText } from '../JobOfferLongText.styled';
import JobOfferSubsection from '../JobOfferSubsection';
import TeamMember from './TeamMember';
import {
  StyledTeamMembers,
  StyledTeamMembersInfo,
  StyledTeamMembersList,
  StyledTeamMembersListContainer
} from './TeamMembers.styled';

const TeamMembers = (props: {
  migratedToMarkdown: boolean;
  membersInfo: string;
  members: UIOfferTeamMember[];
}) => {
  const { t } = useI18n('job-offer');
  const slider = useRef<HTMLDivElement>(null);
  const [slides, setSlides] = useState(1);
  const [allSlidesVisible, setAllSlidesvisible] = useState(false);
  const { membersInfo, members } = props;

  const settings = {
    dots: true,
    arrows: false,
    speed: 300,
    slidesToShow: slides,
    slidesToScroll: slides
  };

  function totalSlides(): void {
    const slideWidth = 320;
    const width = slider.current?.clientWidth || slideWidth;
    let slides;

    if (width > slideWidth) {
      slides = width / slideWidth;

      if (slides > props.members.length) {
        slides = props.members.length;
        setAllSlidesvisible(true);
      } else {
        setAllSlidesvisible(false);
      }
    } else {
      slides = 1;
    }

    setSlides(slides);
  }

  useEffect(() => {
    totalSlides();

    window.addEventListener('resize', totalSlides);

    return () => {
      window.removeEventListener('resize', totalSlides);
    };
  }, []);

  return (
    <StyledTeamMembers>
      <JobOfferSubsection title={t('team.team')}>
        <StyledTeamMembersInfo>
          {props.migratedToMarkdown ? (
            <StyledJobOfferLongText>
              <MarkdownComponent content={membersInfo || ''} />
            </StyledJobOfferLongText>
          ) : (
            <div dangerouslySetInnerHTML={{ __html: membersInfo || '' }}></div>
          )}
        </StyledTeamMembersInfo>
        <StyledTeamMembersListContainer ref={slider}>
          <StyledTeamMembersList
            className={`${allSlidesVisible ? 'is-centered' : ''}`}
          >
            <Slider
              dots={settings.dots}
              arrows={settings.arrows}
              speed={settings.speed}
              slidesToShow={settings.slidesToShow}
              slidesToScroll={settings.slidesToScroll}
            >
              {members.map((m, i) => (
                <TeamMember key={i} members={m}></TeamMember>
              ))}
            </Slider>
          </StyledTeamMembersList>
        </StyledTeamMembersListContainer>
      </JobOfferSubsection>
    </StyledTeamMembers>
  );
};

export default TeamMembers;
